document.addEventListener("DOMContentLoaded", () => {
    window.setTimeout(() => window.initSwipers(), 100);

    document.addEventListener("change", e => {
        if (e.target.matches("select[name='quantity']")) {
            setTimeout(() => window.initSwipers(), 2000);
        }
    });

    document.addEventListener("click", e => {
        if (e.target.closest(".icon-trash")) {
            setTimeout(() => window.initSwipers(), 2000);
        }
    });

    window.addEventListener("open-cart", () => {
        setTimeout(() => {
            window.initSwipers();
        }, 2000);
    });

    const miniCartWrapper = document.querySelector('div[x-show="openMiniCart"]');
    if (miniCartWrapper) {
        const observer = new MutationObserver(() => {
            const isVisible = miniCartWrapper.style.display !== 'none';
            if (isVisible) {
                setTimeout(() => window.initSwipers(), 1000);
            }
        });
        observer.observe(miniCartWrapper, { attributes: true, attributeFilter: ['style'] });
    }
});
